import SoftphoneLine, {
  CallerId,
  SoftphoneCredentials,
} from "@/interfaces/SoftphoneLine";
import api from "./api";

export const softphoneApi = api.injectEndpoints({
  endpoints: (builds) => ({
    getMyLine: builds.query<SoftphoneLine | null, void>({
      query: () => ({ url: "/softphone/my-line" }),
      providesTags: [{ type: "MySoftphoneLine", id: "SELF" }],
    }),
    getMyLineCredentials: builds.query<SoftphoneCredentials, void>({
      query: () => ({ url: "/softphone/my-line/credentials" }),
    }),
    getMyCallerIds: builds.query<CallerId[], void>({
      query: () => ({ url: "/softphone/my-line/caller-ids" }),
    }),
    getMyCurrentCallerId: builds.query<{ number: string | null }, void>({
      query: () => ({ url: "/softphone/my-line/caller-id" }),
      providesTags: [{ type: "MySoftphoneLine", id: "CALLER_ID" }],
    }),
    updateMyCallerId: builds.mutation<void, string>({
      query: (number) => ({
        url: "/softphone/my-line/caller-id",
        method: "PUT",
        body: { number },
      }),
      invalidatesTags: [{ type: "MySoftphoneLine", id: "CALLER_ID" }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetMyLineQuery,
  useLazyGetMyLineCredentialsQuery,
  useLazyGetMyCallerIdsQuery,
  useGetMyCurrentCallerIdQuery,
  useUpdateMyCallerIdMutation,
} = softphoneApi;
